// extracted by mini-css-extract-plugin
export default {"appvide":"FaceRec_appvide__Bm6Fi","appcanvas":"FaceRec_appcanvas__Y0PBT","myapp":"FaceRec_myapp__C2uZl"};